// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_core_shell_header_profile-mannagement_profile-mannagement_module_ts":"b25cbe4af369cc8f","src_app_offline-quote_offline-quote_module_ts":"4d9fc9f3429609e6"}[chunkId] + ".js";
};